import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  scrollContainer: {
    marginTop: 28,
    marginBottom: 28,
  },
  documentContent: {
    wordWrap: 'break-word',
    color: STYLE.COLOR.TEXT1,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    '@media (max-width: 768px)': {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  acceptCheckbox: {
    marginTop: '28px !important',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px !important',
      lineHeight: '20px !important',
    },
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  loader: {
    position: 'relative',
    top: 'unset',
    left: 'unset',
    transform: 'unset',
  },
  applySignatureSection: {
    borderTop: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    paddingTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '28px',
  },
  applySignatureCard: {
    width: '100%',
    background: 'white',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '12px',
    overflow: 'hidden',
  },
  applySignatureCardHeader: {
    background: '#f9fbfc',
    padding: '16px 24px',
    width: '100%',
    boxSizing: 'border-box',
  },
  signatureCardCheckbox: {
    margin: '0 !important',
    alignItems: 'flex-start !important',
    '& .MuiCheckbox-root': {
      padding: '2px !important',
    },
  },
  applySignatureTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingLeft: '10px',
  },
  applySignatureTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    lineHeight: 1.4,
  },
  applySignatureSubtext: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    lineHeight: '20px',
  },
  signatureContainer: {
    alignSelf: 'flex-start',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '16px',
    padding: '11px 22px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: STYLE.COLOR.WHITE,
    boxShadow: '0px 4px 20px 0px rgba(0, 58, 87, 0.05)',
  },
  signatureImage: {
    display: 'block',
    width: '100%',
    height: '78px',
    objectFit: 'contain',
  },
}));
